import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { fetchPlacements } from 'core/actions/ocapi';
import { selectActiveMQ } from 'core/modules/MediaQueries/selectors';
import SectionTitle from 'core/modules/SectionTitle/SectionTitle';
import List from 'core/modules/Partials/List/List';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';

import {
  selectMerchantLogosConfig,
  selectMerchantLogosIsLoading,
  selectMerchantLogosIsLoaded,
  selectMerchantLogosPlacement,
} from './selectors';

import './MerchantLogos.scss';

function MerchantLogos({ title, ignoreWrap }) {
  const config = useSelector(selectMerchantLogosConfig);
  const isLoading = useSelector(selectMerchantLogosIsLoading);
  const isLoaded = useSelector(selectMerchantLogosIsLoaded);
  const placement = useSelector(selectMerchantLogosPlacement);
  const activeMQ = useSelector(selectActiveMQ);

  const { useCarouselOnMediaQueriesOnly, carousel } = config;
  const shouldUseCarousel = useCarouselOnMediaQueriesOnly.includes(activeMQ);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!isLoaded && !isLoading) {
      const { api: { params, options } } = config;
      dispatch(fetchPlacements(params, options));
    }
  }, []);

  const renderImage = ({ assets: { _460x250 } = {}, merchant: { name } = {} }) => (
    <div className="mn_merchantLogo" key={name} data-test="merchant-logo">
      <div className="mn_logoWrapper">
        <img src={_460x250} alt={name} />
      </div>
    </div>
  );

  if (isEmpty(placement)) {
    return null;
  }

  return (
    <div className="mn_merchantLogos">
      <ContentWrap ignoreWrap={ignoreWrap}>
        { title && <SectionTitle title={title} /> }
        <div className={`mn_merchantsList ${shouldUseCarousel ? 'mn_carousel' : '' }`}>
          <List options={carousel} shouldUseCarousel={shouldUseCarousel}>
            {placement.map(renderImage)}
          </List>
        </div>
      </ContentWrap>
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><MerchantLogos {...props} /></ComponentErrorBoundary>;
